//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import action from './action';
import { dataController } from 'components/app';
import config from 'config';

export default {
  name: 'index',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    dataController
  },
  data() {
    return {
      pageTitle: '智能皮肤检测报告',
      reportData: {
        code: undefined,
        data: {},
        msg: undefined
      },
      emptyData: {
        text: '您还没有相应记录',
        image: '/static/img/app/no_article.png'
      },
      nursingContrastData: {},
    }
  },
  async created() {
    this.init();
  },
  mounted() {
    
  },
  methods: {
    ...action
  }
}



// WEBPACK FOOTER //
// ./src/module/app/nursingContrast/page.vue